import React from 'react';
import { FormGroup, Form, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import ServiceTypeSelect from '../../../common/forms/select/ServiceTypeSelect';
import DatePicker from '../../../common/forms/input/DatePicker';
import { isRequired } from '../../../../utils/validators';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import FormFooter from '../../../common/forms/FormFooter';
import { exportRegisteredBusFleets } from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';

const selector = formValueSelector('RegisteredBusFleetSearchForm');

const RegisteredBusFleetSearchForm = ({
  handleSubmit,
  loading,
  fromDateStringValue,
  toDateStringValue,
  showNorthChicoValue,
  showMineValue,
  dispatchExportRegisteredBusFleets,
  serviceTypeValue,
  baseLocationValue,
}) => {
  const handleExport = () => {

    const newFormValues = {
      fromDateString: tzNormalizeDate({ date: fromDateStringValue, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: toDateStringValue, format: INT_DATE_FORMAT }),
      showNorthChico: showNorthChicoValue || false,
      showMine: showMineValue || false,
    }

    if (baseLocationValue) {
      newFormValues.baseLocationId = baseLocationValue.value
    }

    if (serviceTypeValue && serviceTypeValue.length) {
      newFormValues.serviceTypeIds = serviceTypeValue.map(({ value }) => value)
    }

    dispatchExportRegisteredBusFleets(newFormValues);

  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Base">
          <Field
            name="baseLocation"
            component={LocationSelect}
            forHomeBase
            isClearable
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Servicio">
          <Field
            name="serviceType"
            component={ServiceTypeSelect}
            showAll
            isClearable
            isMulti
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Incluir servicio Norte Chico">
          <Field name="showNorthChico" component="input" type="checkbox" />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Incluir buses de mina">
          <Field name="showMine" component="input" type="checkbox" />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonText="Buscar"
        saveButtonIcon="fa fa-search"
        saveButtonColor="primary"
        saveButtonDisabled={loading}
      >
        <Button
          color="success"
          onClick={handleExport}
          disabled={loading}
          className="mr-2"
        >
          <i className="fa fa-file-excel-o" /> Exportar
        </Button>
      </FormFooter>
    </Form>
  );
};

RegisteredBusFleetSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fromDateStringValue: PropTypes.string,
  toDateStringValue: PropTypes.string,
  showNorthChicoValue: PropTypes.bool,
  showMineValue: PropTypes.bool,
  serviceTypeValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  baseLocationValue: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  dispatchExportRegisteredBusFleets: PropTypes.func.isRequired,
};

RegisteredBusFleetSearchForm.defaultProps = {
  loading: false,
  fromDateStringValue: null,
  toDateStringValue: null,
  showNorthChicoValue: false,
  showMineValue: false,
  serviceTypeValue: null,
  baseLocationValue: null,
};

const mapStateToProps = (state) => ({
  fromDateStringValue: selector(state, 'fromDateString'),
  toDateStringValue: selector(state, 'toDateString'),
  showNorthChicoValue: selector(state, 'showNorthChico'),
  showMineValue: selector(state, 'showMine'),
  serviceTypeValue: selector(state, 'serviceType'),
  baseLocationValue: selector(state, 'baseLocation'),
});

const mapDispatchToProps = {
  dispatchExportRegisteredBusFleets: exportRegisteredBusFleets,
};

const form = reduxForm({
  form: 'RegisteredBusFleetSearchForm',
})(RegisteredBusFleetSearchForm);

export default connect(mapStateToProps, mapDispatchToProps)(form);
